const HOST_PANEL_PREVIEW_VERSION = 'HOST_PANEL_PREVIEW_VERSION';

function getUrlQueryParam(key: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(key);
}

function setUrlQueryParam(key: string, value: string) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.set(key, value);
}

function getLocalStorageValue(key: string) {
  let item = null;
  if (window && window.localStorage) {
    item = window.localStorage.getItem(key);
  }

  return item;
}

function setLocalStorageValue(key: string, value: any) {
  if (window && window.localStorage) {
    window.localStorage.setItem(key, value);
  }
}

// Depending on query param load the correct bundle file.
function initLauncher() {
  console.log('[Launcher]: Started Host Panel Launcher');
  let version = getUrlQueryParam('version') || getLocalStorageValue(HOST_PANEL_PREVIEW_VERSION);

  let script = document.createElement('script');
  script.setAttribute('id', 'app');
  script.type = 'text/javascript';
  script.src = '/app.js';

  if (version) {
    setLocalStorageValue(HOST_PANEL_PREVIEW_VERSION, version);
    // Only load the versioned mode when we are not in development, to allow development on features with the versions
    if (process.env.NODE_ENV !== 'development') {
      script.src = '/versions/' + version + '/app.js';

      function isSameOriginScript(src: string | null): src is string {
        if (!src) {
          return false;
        }
        try {
          return new URL(src, window.location.origin).origin === window.location.origin;
        } catch (e: any) {
          console.warn('[Launcher] isSameOriginScript: failed to parse src URL', src, e);
          return false;
        }
      }
      // Webpack marks every chunk it injects with data-webpack, including third-party
      // bundles (Descope) that ship their own webpack runtime. Only rewrite scripts
      // served from this origin — RC paths do not exist on external CDNs.
      function customAppendChild(this: Element, childNode: Node) {
        if (childNode instanceof HTMLScriptElement && childNode.getAttribute('data-webpack')) {
          const src = childNode.getAttribute('src');
          const versionPrefix = `/versions/${version}/`;
          if (isSameOriginScript(src) && !src.includes(versionPrefix)) {
            childNode.setAttribute('src', src.replace(/\/([^/]+\.js)$/, `${versionPrefix}$1`));
          }
        }
        return Node.prototype.appendChild.call(this, childNode);
      }

      // @ts-ignore
      document.head.appendChild = customAppendChild;
    }
    console.log('[Launcher] You are running non stable version: ', version);
  }

  document.body.appendChild(script);
}

initLauncher();
